import { useRouter } from '@application/utils';
import { useMemo } from 'react';
import type { FC } from 'react';
import { useMediaQuery } from 'react-responsive';
import { BREAKPOINTS } from '@presentation/styles';
import itching from '@assets/promos/itching.webp';
import digestion from '@assets/promos/digestion.webp';
import mobility from '@assets/promos/mobility.webp';
import stress from '@assets/promos/stress.webp';
import growth from '@assets/promos/growth.webp';
import itchingDesktop from '@assets/promos/itching_desktop.webp';
import digestionDesktop from '@assets/promos/digestion_desktop.webp';
import mobilityDesktop from '@assets/promos/mobility_desktop.webp';
import stressDesktop from '@assets/promos/stress_desktop.webp';
import growthDesktop from '@assets/promos/growth_desktop.webp';
import { Button } from '../Button';
import * as Styled from './styled';
import type { StoreCardItemPromoProps, StoreCardItemPromoType } from './types';

export * from './types';

const backgroundImages: Record<'desktop' | 'mobile', Record<StoreCardItemPromoType, string>> = {
  desktop: {
    digestion: digestionDesktop,
    growth: growthDesktop,
    itching: itchingDesktop,
    mobility: mobilityDesktop,
    stress: stressDesktop,
  },
  mobile: {
    digestion,
    growth,
    itching,
    mobility,
    stress,
  },
};

const cardThemes: Record<StoreCardItemPromoType, string> = {
  digestion: '#E0DAE4',
  growth: '#CCD3E0',
  itching: '#E0EAD9',
  mobility: '#F8EACB',
  stress: '#B8DDD6',
};

export const StoreCardItemPromo: FC<StoreCardItemPromoProps> = (props) => {
  const { type, onClick, useMobileImage = false } = props;
  const { translate } = useRouter();

  const title = translate(`common.storePromoCard.${type}.title`);
  const cta = translate(`common.storePromoCard.${type}.cta`);

  const isMobile =
    useMediaQuery({ query: `(max-width: ${BREAKPOINTS.medium}px)` }) || useMobileImage;

  const cardTheme = cardThemes[type];
  const backgroundImage = useMemo(() => {
    const imageType = isMobile ? 'mobile' : 'desktop';
    return backgroundImages[imageType][type];
  }, [isMobile, type]);

  return (
    <Styled.Card bg={backgroundImage} bgColor={cardTheme} onClick={onClick}>
      <Styled.Title>{title}</Styled.Title>
      <Styled.ButtonWrapper>
        <Button color="blue" shrink>
          {cta}
        </Button>
      </Styled.ButtonWrapper>
    </Styled.Card>
  );
};
